import React from 'react'
import { Toaster } from 'react-hot-toast';
import Navbar from "../components/Navbar/Navbar";
import NavigationContainer from './NavigationContainer';
import { connect } from 'react-redux'
import Spinner from 'react-bootstrap/Spinner';
import Footer from '../components/Footer/Footer';

const Container = (props) => {
  const { loading, token, email } = props;
  return (
    <div className="main-content">
      <Navbar token={token} loading={loading} email={email} />
        <main className="main-content">
          <Toaster
            position="top-center"
            reverseOrder={false}
            gutter={8}
            toastOptions={{
              duration: 4000,      
            }}
        />
        {
          !loading ?
            (<NavigationContainer />)
            :
            (
              <div className="contenedor-spinner">
                <Spinner color='blue' animation="border" role="status" size='25'>
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            )
        }
          
      </main>
    <Footer/>

    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    loading: state.auth.loading,
    token: state.auth.token,
    email: state.auth.email
  };
};

export default connect(mapStateToProps)(Container)